import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import moment from 'moment';

import Tabs from '../../components/programs/Tabs';
import Curriculum from '../../components/programs/Curriculum';
import Program from '../../components/programs/Program';
import { WarnButton } from '../Membership/styled';
import { AppContext } from '../../providers/AppProvider';
import { LoadingSpinner } from '../../components/_shared';
import { isInProgress } from '../../utils/helper';
import logo from '../../assets/imgs/rabbit.png';
import {
  makeSelectUserMembership,
  makeSelectUser,
} from '../../store/selectors';
import { isEnterprise } from '../../config';

const Container = styled.div`
  @media only screen and (max-width: 639px) {
    padding: 40px 30px;
  }
`;

const EndorsementsTitle = styled.div.attrs({
  className: 'flex items-center w-full text-center justify-center',
})`
  margin: auto;
  margin-top: 120px;
  margin-bottom: 60px;
  font-size: 30px;
  font-weight: 500;

  .optional {
    background: rgba(98, 120, 140, 0.05);
    border-radius: 6px;
    padding: 8px 22px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(98, 120, 140, 0.6);
    margin-left: 20px;
  }

  @media only screen and (max-width: 639px) {
    font-size: 18px;
    line-height: 23px;
    margin-top: 80px;
    margin-bottom: 40px;
  }
`;

const isEnterpriseUser = isEnterprise; // Adjust this line based on how you are determining enterprise users

const WarningBanner = styled.div`
  background-color: #ff5252;
  color: white;
  padding: 10px;
  font-size: 14px;
  text-align: center;
  cursor: pointer;

  b {
    text-decoration: underline;
  }
`;

const Programs = () => {
  const { membershipInfo } = useSelector(makeSelectUser()) || {};
  const membership = useSelector(makeSelectUserMembership());
  const {
    endorsements,
    loading,
    coreCurriculum,
    progress,
    onContinueCourse,
  } = useContext(AppContext);

  const remainingDays = useMemo(() => {
    if (membershipInfo) {
      if (!membershipInfo.enddate) {
        return 99999;
      }

      const end = moment(new Date(Number(membershipInfo.enddate) * 1000));
      const today = moment().startOf('day');
      return Math.round(moment.duration(end - today).asDays());
    }

    return 0;
  }, [membershipInfo]);

  const handleGotoUpgradeMembership = () => {
    window.open(
      'https://www.adventuresincre.com/checkout-aero/accelerator-extension/',
      '_blank'
    );
  };

  if (loading) {
    return (
      <div className="w-full h-full m-auto max-w-6xl flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  const WarnButtonStyle = {
    cursor: isEnterprise === 'true' ? 'default' : 'pointer',
  };

  return (
    <>
      <Container
        className="w-full m-auto bg-transparent sm:flex-grow"
        style={{ maxWidth: 1440 }}
      >
        {/* <Tabs current="base" /> */}
        {coreCurriculum && (
          <Curriculum
            percent={0}
            curriculum={coreCurriculum}
            progress={progress}
            hasStarted={isInProgress(coreCurriculum, progress)}
            onResume={onContinueCourse(coreCurriculum.id)}
          />
        )}
        <EndorsementsTitle>
          <svg
            width="40"
            height="3"
            viewBox="0 0 40 3"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="1.5"
              y1="1.5"
              x2="38.5"
              y2="1.5"
              stroke="#181C34"
              strokeWidth="3"
              strokeLinecap="round"
            />
          </svg>
          <span style={{ marginLeft: 15 }}>Add Specialized Endorsements</span>
          <span className="optional sm:hidden">Optional</span>
        </EndorsementsTitle>
        <div className="-mx-8 flex flex-wrap">
          {endorsements.map((curriculum, id) => (
            <div
              className="px-8 w-1/3 mb-12 sm:w-full sm:mb-5 cursor-pointer"
              key={curriculum.id}
            >
              <Program
                id={id}
                program={curriculum}
                progress={progress}
                locked={membership === 2}
                hasStarted={isInProgress(curriculum, progress)}
                onSelect={onContinueCourse}
              />
            </div>
          ))}
        </div>
        {!isEnterprise && (
          <img className="m-auto w-6 mt-12 mb-20" src={logo} alt="logo" />
        )}
      </Container>
    </>
  );
};

export default Programs;
